import { Box, Typography } from "@mui/material";
import { IDOAShift } from "../../availability-administration/AvailabilityAdministrationData";
import { IEmployee } from "../AvailabilityAdministrationData";
import { ActionMessage } from "./ActionMessage";

interface IStatusInfoProps {
  shift?: IDOAShift,
  employeeData: IEmployee,
  actionMsg?: string,
  selectedRegId: string,
  isDispatchTypeSix: boolean,
  isNightDispatch: boolean,
  availableForFirstOption: boolean,
  availableForSecondOption: boolean,
  availableForBothDoaSelection: number
}

export const StatusInfo: React.FC<IStatusInfoProps> = ({
  shift,
  employeeData,
  actionMsg,
  selectedRegId,
  isDispatchTypeSix,
  isNightDispatch,
  availableForFirstOption,
  availableForSecondOption,
  availableForBothDoaSelection
}) => {
  let statusMsgClassname = 'not-available';
  if ((isDispatchTypeSix || isNightDispatch) && (!!employeeData?.empInfo?.doaSelections ||
    !!employeeData?.empInfo?.dependentShift?.doaSelections)) {
    statusMsgClassname = 'available';
  } else if (!isDispatchTypeSix && !isNightDispatch && employeeData?.empInfo?.doaSelections === 1) {
    // If not dispatch type six, use the employee's availability selection
    statusMsgClassname = 'available';
  }
  return (
    <Box className="status-info">
      <Typography className={`status-wrapper ${employeeData?.empInfo?.doaSelections ? 'available' : ''}`}>
        <Typography component='span' className="status" data-automation="status-lbl">Status:</Typography>
        <Typography component='span' className={`${statusMsgClassname}`} data-automation="status-val">
          {employeeData?.empInfo?.status}
        </Typography>
      </Typography>
      <ActionMessage
        isNightDispatch={isNightDispatch}
        statusMsgClassname={statusMsgClassname}
        shift={shift}
        employeeData={employeeData}
        actionMsg={actionMsg}
        selectedRegId={selectedRegId}
        availableForBothDoaSelection={availableForBothDoaSelection}
        isDispatchTypeSix={isDispatchTypeSix}
      />
    </Box>
  )
}